/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 *
 * 联调服：'http://101.37.172.241:2600//api/v1/android/'
 */
import { $isXunMengTu } from '@/util/util'

// let domainDev = 'https://dev3-api.xunyou.mobi/'
// let domainDevPortal = 'https://dev3-portal.xunyou.mobi/'

const environment = ['test-', 'localhost']
let baseUrl = environment.some((cur) => {
  return location.host.includes(cur)
}) ? ($isXunMengTu() ? {
  // 迅猛兔
  'base': 'https://test-api.xunmengtu.com/api/v1/xunmengtu_android/',
  'baseV2': 'https://test-api.xunmengtu.com/api/v2/xunmengtu_android/',
  'portalV2': 'https://test-portal.xunmengtu.com/api/v2/xunmengtu_android/',
  'portal': 'https://test-portal.xunmengtu.com/api/v1/xunmengtu_android/',
  'portalV7': 'https://test-portal.xunmengtu.com/api/v7/xunmengtu_android/',
  'portalNoGuid': 'https://test-portal.xunmengtu.com/api/v1/xunmengtu_android/',
  'httpbase': 'https://test-api.xunmengtu.com/api/v1/xunmengtu_android/',
  'gateway': 'https://test-api.xunmengtu.com/apis/v1/xunmengtu_android/',
  'report': 'https://test-drone.xunmengtu.com:504/',
  'portalImg': 'https://subao-xmt-portal-img-test.oss-cn-shanghai.aliyuncs.com/newManager/',
  'portalConfig': 'https://subao-xmt-portal-img-test.oss-cn-shanghai.aliyuncs.com/newOnline/'
} : {
  'base': 'https://test-api.xunyou.mobi/api/v1/android/',
  'baseV2': 'https://test-api.xunyou.mobi/api/v2/android/',
  'portalV2': 'https://test-portal.xunyou.mobi/api/v2/android/',
  'portal': 'https://test-portal.xunyou.mobi/api/v1/android/',
  'portalV7': 'https://test-portal.xunyou.mobi/api/v7/android/',
  'portalNoGuid': 'https://test-portal.xunyou.mobi/api/v1/android/',
  'httpbase': 'https://test-api.xunyou.mobi/api/v1/android/',
  'gateway': 'https://test-api.xunyou.mobi/apis/v1/android/',
  'report': 'https://test-drone.xunyou.mobi:504/',
  'portalImg': 'https://subao-portal-img-test.oss-cn-beijing.aliyuncs.com/newManager/',
  'portalConfig': 'https://subao-portal-img-test.oss-cn-beijing.aliyuncs.com/newOnline/'
  // 个人联调服，
    // 'base': `${domainDev}api/v1/android/`,
    // 'baseV2': `${domainDev}api/v2/android/`,
    // 'portalV2': `${domainDevPortal}api/v2/android/`,
    // 'portal': `${domainDevPortal}api/v1/android/`,
    // 'portalV7': `${domainDevPortal}api/v7/android/`,
    // 'portalNoGuid': `${domainDevPortal}api/v1/android/`,
    // 'httpbase': `${domainDev}api/v1/android/`,
    // 'gateway': `${domainDev}apis/v1/android/`,
    // 'report': 'https://dev-drone.xunyou.mobi:504/',
    // 'portalImg': 'https://subao-portal-img-dev.oss-cn-shanghai.aliyuncs.com/newManager/',
    // 'portalConfig': 'https://subao-portal-img-test.oss-cn-beijing.aliyuncs.com/newOnline/'
}) : (
  $isXunMengTu() ? {
    'base': 'https://api.xunmengtu.com/api/v1/xunmengtu_android/',
    'baseV2': 'https://api.xunmengtu.com/api/v2/xunmengtu_android/',
    'portalV2': 'https://portal.xunmengtu.com/api/v2/xunmengtu_android/',
    'portal': 'https://portal.xunmengtu.com/api/v1/xunmengtu_android/',
    'portalV7': 'https://portal.xunmengtu.com/api/v7/xunmengtu_android/',
    'portalNoGuid': 'https://portal.xunmengtu.com/api/v1/xunmengtu_android/',
    'httpbase': 'http://api.xunmengtu.com/api/v1/xunmengtu_android/',
    'gateway': 'https://api.xunmengtu.com/apis/v1/xunmengtu_android/',
    'report': 'https://drone.xunmengtu.com:504/',
    'portalImg': 'https://d-portal.xunmengtu.com/newOnline/',
    'portalConfig': 'https://d-portal.xunmengtu.com/newOnline/'
  } : {
    'base': 'https://api.xunyou.mobi/api/v1/android/',
    'baseV2': 'https://api.xunyou.mobi/api/v2/android/',
    'portalV2': 'https://portal.xunyou.mobi/api/v2/android/',
    'portal': 'https://portal.xunyou.mobi/api/v1/android/',
    'portalV7': 'https://portal.xunyou.mobi/api/v7/android/',
    'portalNoGuid': 'https://portal.xunyou.mobi/api/v1/android/',
    'httpbase': 'http://api.xunyou.mobi/api/v1/android/',
    'gateway': 'https://api.xunyou.mobi/apis/v1/android/',
    'report': 'https://drone.xunyou.mobi:504/',
    'portalImg': 'https://d.portal.xunyou.mobi/newOnline/',
    'portalConfig': 'https://d.portal.xunyou.mobi/newOnline/'
  }
)

export {
  baseUrl
}
